import { getEnvValue } from "@is/utils/env";

import { EventTracking } from "./EventTracking";

EventTracking.initialize({
  apiUrl: getEnvValue("VITE_INSTORE_EVENT_TRACKING_SERVICE_URL"),
});

export const trackEvent = EventTracking.instance.track;
